var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFaqTires = function SvgFaqTires(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#faq-tires_svg__a)",
    fillRule: "evenodd",
    d: "M12.333 18.008A4.25 4.25 0 0 0 14 18.35c.59 0 1.129-.114 1.626-.332l2.641 3.211c.6-.352 1.15-.777 1.647-1.264l-2.641-3.2c.59-.725.963-1.647.963-2.662v-.051l4.008-1.71a8.5 8.5 0 0 0-.663-1.967l-3.894 1.657a4.25 4.25 0 0 0-2.651-2.03v-4.34A9 9 0 0 0 14 5.59c-.352 0-.694.031-1.036.073v4.34a4.27 4.27 0 0 0-2.651 2.03l-3.894-1.658a8 8 0 0 0-.663 1.968l4.008 1.709v.051c0 1.005.363 1.906.942 2.631l-2.64 3.21a8.4 8.4 0 0 0 1.636 1.264l2.64-3.2zM14 11.566c1.409 0 2.548 1.14 2.548 2.548s-1.14 2.548-2.548 2.548-2.548-1.14-2.548-2.548 1.14-2.548 2.548-2.548",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#faq-tires_svg__b)",
    fillRule: "evenodd",
    d: "M14-.002C6.275-.002-.002 6.284-.002 14s6.276 14.003 14.003 14.003c7.726 0 14.002-6.277 14.002-14.003S21.727-.002 14.001-.002m0 23.965c-5.489 0-9.963-4.474-9.963-9.963 0-5.49 4.474-9.963 9.964-9.963 5.489 0 9.963 4.474 9.963 9.963 0 5.49-4.474 9.963-9.963 9.963",
    clipRule: "evenodd",
    opacity: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "faq-tires_svg__a",
    x1: 14,
    x2: 14,
    y1: 21.229,
    y2: 5.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#00CDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DCCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "faq-tires_svg__b",
    x1: 14.001,
    x2: 14.001,
    y1: 28.003,
    y2: -0.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#00CDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DCCF"
  })))));
};
export default SvgFaqTires;